import { render, staticRenderFns } from "./MeasuresModal.vue?vue&type=template&id=3f275524"
import script from "./MeasuresModal.vue?vue&type=script&lang=js"
export * from "./MeasuresModal.vue?vue&type=script&lang=js"
import style0 from "./MeasuresModal.vue?vue&type=style&index=0&id=3f275524&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports